import * as types from './mutation-types'

const mutations = {
  [types.SET_FOLD](state, isFold) {
    state.isFold = isFold
  }
}

export default mutations
